{
  "nav": {
    "primary": "Utama",
    "login": "Log masuk",
    "getStarted": "Mula sekarang"
  },
  "home": {
    "title": "Planetra — perisikan geospatial untuk perancang bandar Malaysia",
    "description": "Klasifikasikan imej satelit, bandingkan dengan Guna Tanah, dan hasilkan bukti perancangan yang boleh dipertahankan.",
    "tagline": "Imej satelit, analisis guna tanah dan simulasi perancangan dalam satu ruang kerja.",
    "capabilities": {
      "imagery": {
        "title": "Imej",
        "body": "Tempah dan klasifikasikan imej satelit bagi mana-mana kawasan kajian."
      },
      "analysis": {
        "title": "Analisis",
        "body": "Bandingkan litupan bumi yang diperhatikan dengan Guna Tanah yang diwartakan dan kenal pasti setiap percanggahan."
      },
      "simulation": {
        "title": "Simulasi",
        "body": "Modelkan cadangan pembangunan dan lihat kesannya sebelum ia diluluskan."
      }
    }
  },
  "footer": {
    "rights": "© Planetra. Dibina untuk perancang bandar Malaysia."
  }
}
